import { selectOdetLeergebiedNode } from '@newStore/documentUI/transformContent/odetContentNodeSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { identifierComponent } from '@nodeTypeConfig/helpers/editComponents/identifierComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const CURRICULUM_ODET_LEERGEBIED: BuildingBlockNodeConfig = {
  nodeSelector: selectOdetLeergebiedNode,
  information: {
    single: 'Leergebied',
    plural: 'Leergebieden',
  },

  buildingBlocks: [
    { type: NodeType.CURRICULUM_ODET_SUBSECTION },
    { type: NodeType.CURRICULUM_ODET_ENDTERM },
  ],
  edit: [
    {
      ...identifierComponent,
      width: 2,
    },
    {
      ...titleComponent,
      width: 10,
    },
    descriptionComponent,
  ],
  isCollapsible: true,
  isCollapsedByDefault: true,
  isDeprecated: true,
  documentViewIdentifier: 'i',
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default CURRICULUM_ODET_LEERGEBIED;
